import { NavItemType } from 'types/menu';

// Fallback estático del menú. La fuente de verdad es sys_menu_items (BD);
// este archivo se usa solo como referencia/fallback offline.
// Cada item incluye `viewKey` + `permission` para que pueda renderizarse
// correctamente vía DynamicRoute si llegara a usarse.
const pages: NavItemType = {
  id: 'pages',
  title: 'Menú',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      viewKey: 'dashboard.home',
      permission: 'dashboard.view',
      icon: 'ph ph-house',
      breadcrumbs: false
    },
    {
      id: 'administracion',
      title: 'Administración',
      type: 'collapse',
      icon: 'ph ph-sliders',
      children: [
        { id: 'usuarios',     title: 'Usuarios',      type: 'item', url: '/administration/users',            viewKey: 'users.list',            permission: 'users.view',            icon: 'ph ph-user-circle' },
        { id: 'perfiles',     title: 'Perfiles',      type: 'item', url: '/administration/profiles',         viewKey: 'profiles.list',         permission: 'profiles.view',         icon: 'ph ph-shield-check' },
        { id: 'sesiones',     title: 'Sesiones',      type: 'item', url: '/administration/sessions',         viewKey: 'sessions.list',         permission: 'sessions.view',         icon: 'ph ph-monitor' },
        { id: 'auditoria',    title: 'Auditoría',     type: 'item', url: '/administration/audit-logs',       viewKey: 'audit-logs.list',       permission: 'audit-logs.view',       icon: 'ph ph-clipboard-text' },
        { id: 'menu-items',   title: 'Menu Items',    type: 'item', url: '/administration/menu-items',       viewKey: 'menu-items.list',       permission: 'menu-items.view',       icon: 'ph ph-list' },
        { id: 'bus-config',   title: 'Configuración', type: 'item', url: '/administration/business-config',  viewKey: 'business-config.list',  permission: 'business-config.view',  icon: 'ph ph-wrench' },
        {
          id: 'email',
          title: 'Email',
          type: 'collapse',
          icon: 'ph ph-envelope',
          children: [
            { id: 'email-senders',   title: 'Senders',    type: 'item', url: '/administration/email/senders',    viewKey: 'email-senders.list',   permission: 'email-senders.view',   icon: 'ph ph-plugs' },
            { id: 'email-templates', title: 'Templates',  type: 'item', url: '/administration/email/templates',  viewKey: 'email-templates.list', permission: 'email-templates.view', icon: 'ph ph-file-html' },
            { id: 'email-logs',      title: 'Logs Email', type: 'item', url: '/administration/email/logs',       viewKey: 'email-logs.list',      permission: 'email-logs.view',      icon: 'ph ph-list-checks' },
            { id: 'email-witnesses', title: 'Testigos',   type: 'item', url: '/administration/email/witnesses',  viewKey: 'email-witnesses.list', permission: 'email-witnesses.view', icon: 'ph ph-eye' }
          ]
        }
      ]
    },
    {
      id: 'sistema',
      title: 'Sistema',
      type: 'collapse',
      icon: 'ph ph-gear',
      children: [
        { id: 'sys-config', title: 'Config. Sistema', type: 'item', url: '/system/config', viewKey: 'system-config.list', permission: 'system-config.view', icon: 'ph ph-sliders-horizontal' },
        {
          id: 'security',
          title: 'Seguridad',
          type: 'collapse',
          icon: 'ph ph-shield',
          children: [
            { id: 'rate-limit-web', title: 'Throttle Web', type: 'item', url: '/system/security/throttle-web', viewKey: 'security.throttle-web', permission: 'security.view', icon: 'ph ph-shield-warning' }
          ]
        },
        { id: 'tracking-visits', title: 'Visitas Web', type: 'item', url: '/system/tracking-visits', viewKey: 'tracking-visits.list', permission: 'tracking-visits.view', icon: 'ph ph-monitor-play' }
      ]
    }
  ]
};

export default pages;
